module.exports = __webpack_public_path__ + "img/check.8b982366.svg";